import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Política de Privacidad</h2>
                <p>Política de Privacidad de Dreamehome</p>
                <p>Presentación</p>
                <p>El servicio "Dreamehome" es operado por Dreame Innovation Technology (Suzhou) Co., Ltd. y sus compañías afiliadas
                    (en lo sucesivo, "nosotros" o "Dreame") para brindarle una plataforma (o servicio) dedicada a control
                    inteligente de
                    dispositivos y servicios de gestión. Reconocemos y entendemos la importancia de su información personal para
                    usted y
                    haremos todo lo posible para proteger la seguridad de dicha información. Adoptaremos las medidas protectoras de
                    seguridad correspondientes para proteger su información personal de acuerdo con estándares de seguridad
                    reconocidos
                    por la industria.</p>
                <p>.</p>
                <p>Antes de utilizar nuestros productos (o servicios), lea atentamente para comprender la Política de Privacidad de
                    Dreamehome.</p>
                <p>Si es menor de edad, debe tener el permiso de sus padres o guardianes legales para usar esta aplicación y pedir
                    que
                    lean estos términos con usted.</p>
                <p>Hemos tenido plenamente en cuenta sus necesidades al formular esta Política de privacidad. Es muy importante que
                    comprenda completamente nuestras prácticas de recolección y uso de información personal, así como nuestros
                    esfuerzos
                    para garantizar que, en última instancia, pueda administrar y controlar la información personal que nos
                    proporciona.
                    Esta Política de privacidad cubre cómo colectamos, usamos, divulgamos, procesamos y retenemos la información que
                    nos
                    proporciona al usar nuestra aplicación. Cumpliremos estrictamente con esta Política de Privacidad al usar su
                    información.</p>
                <p>Esta Política de Privacidad le ayudará a comprender:</p>
                <p>I. Qué información colectamos y cómo la usamos</p>
                <p>II. Cómo utilizamos las cookies y tecnologías similares</p>
                <p>III. Cómo encomendamos el procesamiento, compartimos, transferimos y divulgamos al público su información
                    personal
                </p>
                <p>IV. Cómo retenemos y protegemos su información personal</p>
                <p>V. Sus derechos</p>
                <p>VI. Cómo manejamos la transferencia transfronteriza de datos</p>
                <p>VII. Nuestra información de contacto</p>
                <p>VIII. Cómo actualizamos la Política de Privacidad</p>
                <p>Apéndice I: Detalles de los SDK de terceros</p>
                <p>Nuestro objetivo es ofrecerle la mejor experiencia de usuario. Contamos con expertos de protección de datos (DPO
                    por sus siglas inglesas) dedicados en diferentes países y regiones para solucionar sus problemas de privacidad
                    de
                    datos. Si tiene pregunta sobre esta Política de Privacidad, puede comunicarse con el DPO correspondiente con la
                    información de contacto adjunta en la Sección VII. Nuestro DPO responderá a su solicitud dentro del tiempo
                    requerido
                    por las políticas y leyes nacionales relevantes. Si no está satisfecho con nuestra respuesta, especialmente si
                    cree
                    que nuestro procesamiento de información personal ha dañado sus derechos e intereses legítimos, puede presentar
                    una
                    demanda en el tribunal popular de jurisdicción, entregar una queja a las agencias reguladoras del gobierno o
                    resolver su problema a través de otros canales externos.</p>
                <p>I. Qué información colectamos y cómo la usamos</p>
                <p>La información personal se refiere a cualquier información anotada electrónicamente o de otras formas que pueda
                    usarse sola o en combinación con otra información para identificar a una persona física específica.</p>
                <p>La información personal sensible se refiere a información que una vez accedida indebidamente, proporcionada
                    ilegalmente o abusada, podría poner en peligro la seguridad personal y de la propiedad, o causar daños a la
                    reputación personal, salud mental y física, o trato discriminatorio, etc. La información personal sensible
                    incluye
                    pero no se limita a números de identificación, información biométrica personal, información de cuenta bancaria,
                    información de propiedad, historial de paradero, información de transacciones y la información personal de
                    menores
                    de 14 años (incluidos), etc.</p>
                <p>El propósito de colectar su información personal es proporcionarle productos y/o servicios, y prometemos usarla
                    de
                    acuerdo con las leyes, reglamentos y otros documentos normativos aplicables. Usted tiene derecho a elegir si
                    desea
                    proporcionar dicha información. Pero en la mayoría de los casos, si no lo proporciona, es posible que no podamos
                    brindarle los servicios correspondientes ni responder a sus solicitudes.</p>
                <p>(A) Dreamehome colecta y procesa su información personal para brindar servicios fundamentales</p>
                <p>(1) Conexión y administración de dispositivos</p>
                <p>Con el fin de brindar servicios para que usted pueda conectar y administrar de manera segura sus dispositivos
                    inteligentes, podemos colectar su información de WiFi, información de ubicación, información de cuenta de inicio
                    de
                    sesión, información relacionada con el teléfono móvil, información del dispositivo inteligente e información
                    asociada con su cuenta de Dreame y dispositivo inteligente. La información se utilizará para habilitar funciones
                    como Conexión Rápida, Conexión, Buscar Dispositivos Cercanos y Administración de Dispositivos. Específicamente,
                    la
                    información que colectamos incluye:</p>
                <p>Información de la cuenta de inicio de sesión: nombre de usuario, contraseña, apodo, foto de perfil, dirección de
                    correo electrónico y número de teléfono de su cuenta Dreame. Entre ellos, su nombre de usuario, contraseña,
                    número
                    de teléfono y dirección de correo electrónico son información personal sensible. Dicha información se colecta
                    para
                    verificar su identidad y ayudarlo a obtener el permiso para acceder al servidor con su cuenta de Dreamehome. El
                    nombre de usuario y la contraseña que ingrese serán encriptados y transmitidos al servidor de Dreame para la
                    autenticación de inicio de sesión.</p>
                <p>Información relacionada con el teléfono móvil: identificación del dispositivo (IMEI/OAID, dirección Mac e ID de
                    Android), modelo de teléfono, versión del sistema, país o región, tamaño y resolución de la pantalla, CPU e
                    información relacionada con el dispositivo de visualización. Esta información se colecta para permitirle
                    conectar
                    Dreamehome con sus dispositivos inteligentes.</p>
                <p>Información del dispositivo inteligente: nombre del dispositivo, modelo, versión, fabricante, identificador,
                    dirección MAC, dirección IP, estado de operación, atributos personalizados, configuración de parámetro, control
                    de
                    eventos de operación y dispositivo, e historiales de uso. Esta información se colecta para conectar su
                    dispositivo
                    inteligente para que usted pueda controlar y administrar el dispositivo, configurar atributos y parámetros del
                    dispositivo y ver el estado de funcionamiento y los historiales de su dispositivo.</p>
                <p>(2) Actualización de su Dreamehome y dispositivo inteligente</p>
                <p>Para garantizar que usted pueda disfrutar continuamente de nuestros nuevos servicios, podemos utilizar la
                    información de la versión de su Dreamehome y el modelo de teléfono para proporcionar servicios actualizados.
                    Además,
                    también podemos colectar su lista de dispositivos conectados y la información de la versión para proporcionar
                    servicios actualizados (incluida la versión de firmware). Dreamehome solo proporciona servicios actualizados
                    para
                    sus dispositivos inteligentes. El fabricante del dispositivo inteligente proporciona el firmware correspondiente
                    y
                    será responsable de la calidad del firmware y resultados de la actualización.</p>
                <p>Si elige no proporcionar esta información, no podrá actualizar Dreamehome ni su dispositivo inteligente.</p>
                <p> (3) Respuesta a consultas en línea </p>
                <p>Para ayudarle a resolver los posibles problemas de Dreamehome y su dispositivo inteligente, ofrecemos un servicio
                    de consulta en línea, lo cual requiere su información personal, que incluye: información de Dreamehome y su
                    dispositivo inteligente, su información de contacto, descripciones del problema y fotos y videos relevantes. La
                    información de la aplicación y del dispositivo incluye el estado del dispositivo, la información detectada por
                    los
                    sensores, los historiales de funcionamiento del dispositivo, los identificadores del dispositivo, etc. Esta
                    información se colecta para analizar e identificar las causas del problema. Su información de contacto se
                    colecta
                    para que podamos rastrear y hacer un seguimiento de su consulta y resolver su consulta.</p>
                <p>Su información personal solo se utilizará para analizar y resolver problema y no se divulgará públicamente ni se
                    utilizará para fines comerciales. Si no proporciona dicha información, no podremos identificar ni resolver sus
                    problemas de manera efectiva.</p>
                <p>(B) Dreamehome colecta y procesa su información personal para ofrecer funciones adicionales</p>
                <p>Además de brindar los servicios fundamentales de Dreamehome, es posible que también necesitemos colectar y
                    utilizar
                    su información personal para algunas funciones adicionales. Si usted no proporciona esta información, puede
                    seguir
                    usando los servicios fundamentales de Dreamehome, pero es posible que no pueda usar las funciones adicionales
                    que
                    pueden brindarle más conveniencia. Aparte de los servicios fundamentales, Dreamehome también ofrece:</p>
                <p>Programa de Mejora de la Experiencia del Usuario:</p>
                <p>Para mejorar su experiencia de usuario, necesitamos colectar los historiales de Dreamehome, incluidos los
                    registros
                    de procesos de claves codificadas, registros de eventos, registros de fallas, eventos de operación, uso de cada
                    interfaz, etc. Su información personal sensible no se anotará en los registros.</p>
                <p>Su información personal se utilizará de las siguientes formas: la información anterior se colecta y cargará
                    automáticamente en el servidor; la información de registro se analizará para diagnosticar el estado de la
                    operación
                    y analizar el uso de la aplicación.</p>
                <p>Si no proporciona esta información, Dreamehome no podrá mejorar su experiencia de usuario de forma personalizada,
                    pero usted puede seguir utilizando los servicios fundamentales de Dreamehome(C) Podemos colectar su información
                    personal desde terceros.</p>
                <p>En algunas circunstancias, podemos adquirir legalmente su información personal desde un tercero.</p>
                <p>Con su autorización, cooperaremos con proveedores de servicios externos en manejar sus dispositivos inteligentes,
                    durante cuyo proceso colectaremos su información personal de proveedores de servicios externos. Si usted
                    administra
                    su dispositivo inteligente con una cuenta de terceros, obtendremos su información personal cuando su aplicación
                    se
                    vincula con la dicha cuenta. Se colecta la siguiente información:</p>
                <p>La información de su cuenta de terceros, incluidos su apodo y foto de perfil, que se mostrará en la Dreamehome;
                </p>
                <p>Información del dispositivo y de la red, incluido el identificador del dispositivo, la dirección MAC y el número
                    de
                    serie del dispositivo para reconocer el dispositivo actual y activar el control de seguridad.</p>
                <p>Si el procesamiento de su información personal para la operación excede el alcance de su autorización y
                    consentimiento originales al proporcionar la información a un proveedor de servicios externo, obtendremos su
                    consentimiento claro antes de procesar su información. Además, cumpliremos estrictamente con las leyes y
                    reglamentos
                    pertinentes y exigiremos a los proveedores de servicios externos relevantes que garanticen la legalidad de la
                    información que brindan.</p>
                <p>(D) Información no personal</p>
                <p>También podemos colectar otra información que no se puede usar para identificar a un individuo específico (es
                    decir, información no relacionada a la identidad de una persona), como datos estadísticos generados al usar un
                    servicio específico, como comportamientos del usuario (incluidos clics, saltos de página y tiempo de
                    navegación).
                    Esta información se colecta para mejorar nuestros servicios. Las categorías y cantidades de información
                    colectada
                    dependen de cómo usted utilice nuestros productos y/o servicios. Colectamos esta información para poder
                    proporcionarle información más útil y comprender mejor las preferencias de los clientes para optimizar nuestro
                    sitio
                    web, productos y servicios. En esta Política de Privacidad, los datos colectados se consideran información no
                    personal. Cuando combinamos información no personal con información personal para uso conjunto, la primera
                    también
                    se considerará información personal.</p>
                <p>II. Cómo utilizamos las cookies y tecnologías similares</p>
                <p>Para garantizar el funcionamiento normal de Dreamehome, almacenaremos un pequeño archivo de datos llamado Cookie
                    en
                    su dispositivo. La cookie normalmente incluye identificadores, nombres de sitios y algunos números y caracteres.
                    Gracias a la Cookie, Dreamehome puede almacenar su cuenta de inicio de sesión del sitio web, preferencias y
                    otros
                    datos.</p>
                <p>No utilizaremos cookies para ningún otro propósito que no sea indicado en esta Política de Privacidad. Puede
                    administrar o eliminar las cookies según sus preferencias. Pero si hace esto, en algunos casos, su acceso seguro
                    a
                    Dreamehome puede verse afectado y es posible que necesite cambiar la configuración del usuario cada vez que
                    acceda a
                    Dreamehome.</p>
                <p>III. Cómo encomendamos el procesamiento, compartimos, transferimos divulgamos al público su información personal
                </p>
                <p>(A) Procesamiento encomendado</p>
                <p>Bajo algunas circunstancias, Dreame puede encomendar a otras empresas el procesamiento de su información
                    personal,
                    como contactarlo a usted, enviarle correos electrónicos o brindarle asistencia técnica en nuestro nombre. Estas
                    empresas solo pueden usar su información personal para ofrecerle servicios en nuestro nombre.</p>
                <p>Firmaremos un estricto acuerdo de confidencialidad o un acuerdo de procesamiento de información personal con la
                    parte encomendada, y le exigiremos que procese su información personal de acuerdo con esta Política de
                    Privacidad y
                    que adopte las medidas de confidencialidad y seguridad pertinentes.</p>
                <p>(B) Compartir</p>
                <p>En general, Dreame no compartirá su información personal con otras empresas, organizaciones o personas, excepto
                    en
                    los siguientes casos:</p>
                <p>1. Con su consentimiento y dentro de su autorización con un tercero, compartiremos la información, que incluye
                    datos y configuración de los productos de su hogar inteligente, con sus familiares y amigos para permitirles a
                    ellos
                    obtener un acceso rápido al software y servicios en sus propios dispositivos terminales.</p>
                <p>2. Algunos servicios de Dreamehome, como alojamiento de sitios web, análisis de datos, procesamiento de pagos y
                    tarjetas de crédito, suministro de infraestructura, servicios de TI, servicios de atención al cliente, envío de
                    correo electrónico y otros servicios similares, son proporcionados por proveedores de servicios externos. Por
                    esta
                    razón, necesitamos proporcionarles parte de su información personal a ellos para que puedan brindarnos dichos
                    servicios.</p>
                <p>3. Podemos divulgar su información personal a nuestros clientes y otros socios comerciales que, directa o
                    indirectamente, proporcionen dispositivos inteligentes y / o redes y sistemas para que usted acceda y utilice
                    nuestros sitio web y servicios.</p>
                <p>4. Si Dreame experimenta una reorganización, fusión, venta de activos, empresa conjunta, enajenación,
                    transferencia
                    u otras circunstancias en las que todo o parte de nuestro negocio, activos o acciones deben eliminarse
                    (incluidos,
                    entre otros, cualquier procedimiento de bancarrota o procedimiento similar relacionado con las circunstancias
                    anteriores), podemos divulgar su información personal a empresas afiliadas u otros terceros. Antes de que esto
                    suceda, usted recibirá una notificación clara por correo electrónico y/o nuestro sitio web sobre el cambio de
                    propiedad, la incompatibilidad del nuevo uso de la información personal y la autorización de su información
                    personal.</p>
                <p>5. Si creemos de buena fe que el acceso, uso, preservación o divulgación de la información son necesarios para:
                    (a)
                    cumplir con las leyes y reglamentos aplicables; (b) cumplir con los procedimientos legales; (c) responder a los
                    requisitos de las instituciones públicas y las autoridades gubernamentales, incluidas las que se encuentran
                    fuera
                    del país/ de la región donde usted vive; (d) cumplir con nuestros términos y condiciones; (e) proteger nuestras
                    operaciones, negocios y sistemas; (f) proteger los derechos, la privacidad, la seguridad o la propiedad de
                    nosotros
                    y/o de otros usuarios, incluido/a usted; y (g) buscar los remedios disponibles o limitar las compensaciones por
                    daños que debamos proporcionar.</p>
                <p>6. Podemos divulgar su información personal a nuestras sucursales o compañías afiliadas para que lleven a cabo
                    actividades comerciales regularmente.</p>
                <p>7. Compartiremos los datos necesarios con terceros a través de interfaces de programación de aplicaciones (API
                    por
                    sus siglas inglesas) y kits de desarrollo de herramientas de software (SDK por sus siglas inglesas). Los SDK de
                    terceros varían de diferentes versiones y generalmente incluyen tipos de inicio de sesión de cuentas de
                    terceros, de
                    uso compartido, de pago de cuentas de terceros, de notificación push del fabricante, de estadísticas, etc.
                    Realizaremos estrictas inspecciones de seguridad en terceros, con los que llegamos a un acuerdo sobre medidas
                    protectoras de datos. En el Apéndice 1, enumeramos detalles de los SDK de terceros a los que autorizamos el
                    acceso.
                    Léalo detenidamente. Nuestra Política de Privacidad no se aplica a productos o servicios proporcionados por
                    terceros. Su información personal puede ser colectada cuando usted utiliza estos productos o servicios. Por
                    ello, le
                    recomendamos que se tome el tiempo par leer la política de privacidad de los terceros, al igual que leer la
                    nuestra.
                    No tenemos ninguna responsabilidad ni control sobre cómo los terceros utilizan la información que colectaron de
                    usted. Nuestra Política de Privacidad no se aplica a otros sitios web vinculados a través de nuestros servicios.
                    Usted debe asumir la responsabilidad de proteger su información personal al interactuar con los sitios web
                    vinculados. Antes de que usted ingrese a la página de terceros por primera vez, el proveedor de servicios
                    externo le
                    mostrará los acuerdos y declaraciones de privacidad relevantes. Léalos atentamente por favor.</p>
                <p>(C) Transferencia</p>
                <p>Dreame no transferirá su información personal a ninguna empresa, organización o individuo, excepto en los
                    siguientes casos:</p>
                <p>1. Con su consentimiento explícito: solo transferiremos su información personal a otros habiendo obtenido su
                    consentimiento explícito;</p>
                <p>2. Si Dreame experimenta en una fusión, adquisición o liquidación por quiebra que requiera la transferencia de
                    información personal, exigiremos que la nueva compañía u organización que posee su información personal siga
                    sujeta
                    a esta Política de Privacidad; de lo contrario, exigiremos que la empresa u organización obtenga su autorización
                    nuevamente.</p>
                <p>(D) Divulgación al público</p>
                <p>No divulgamos al público su información personal, excepto en las siguientes circunstancias:</p>
                <p>1. Con su consentimiento explícito;</p>
                <p>2. Cuando tengamos una base legal: podemos divulgar al público su información personal de conformidad con la ley
                    o
                    basándonos en procedimientos legales, litigios o requisitos obligatorios de las autoridades gubernamentales.</p>
                <p>IV. Cómo retenemos y protegemos su información personal</p>
                <p>Retenemos la información personal dentro del período necesario para la colección de información descrita en esta
                    Política de Privacidad o para cumplir con los requisitos legales aplicables. Dejaremos de almacenar su
                    información
                    personal y la eliminaremos o anonimizaremos después de haber logrado el propósito de la colección, o después de
                    haber confirmado su solicitud de eliminación o cancelación, o después de haber finalizado la operación de los
                    productos o servicios correspondientes. Si es de interés público, científico, de investigación histórica o con
                    fines
                    estadísticos, seguiremos reteniendo datos relevantes de acuerdo con las leyes aplicables, incluso si el
                    procesamiento adicional de datos no tiene que ver con el propósito original de colección.</p>
                <p>Cuando se trata de Dreamehome, el tiempo de retención específico de sus datos personales es el siguiente:</p>
                <p>En el caso de datos almacenados localmente en Dreamehome, cuando usted desinstala la aplicación o borra los datos
                    de la aplicación, todos los datos almacenados se eliminarán inmediatamente.</p>
                <p>En el caso del dispositivo inteligente y el almacenamiento de datos de operación en el servidor, si usted elimina
                    el dispositivo inteligente, se niega a aceptar la Política de Privacidad de Dreamehome y deja de usar los
                    servicios
                    de Dreamehome, todos los datos almacenados se eliminarán de inmediato.</p>
                <p>En el caso de los registros de operación, datos estadísticos y registros históricos almacenados en el servidor,
                    los
                    eliminamos al limpiar los datos del servidor de vez en cuando. Normalmente, los datos se retienen por no más de
                    2
                    años.</p>
                <p>Además, en caso de que Dreame termine el funcionamiento de los productos o servicios correspondientes, le
                    informaremos mediante notificaciones push, anuncios, etc. y borraremos o anonimizaremos su información personal
                    en
                    un plazo razonable.</p>
                <p>V. Sus derechos</p>
                <p>(A) Acceso, rectificación y eliminación</p>
                <p>De acuerdo con las leyes y regulaciones locales aplicables, usted tiene el derecho a solicitar el acceso, la
                    rectificación y la cancelación de cualquier dato que colectemos de usted (en lo sucesivo, la "solicitud"). Por
                    favor, escríbanos o póngase en contacto con nosotros en el sitio web de Dreamehome. Conforme a la mayoría de las
                    leyes, la solicitud de sujetos de datos personales debe cumplir con requisitos específicos.</p>
                <p>En la presente Política de privacidad, se requiere que sus solicitudes cumplan con las siguientes circunstancias:
                </p>
                <p>Debe realizar la solicitud a través de nuestros canales dedicados a la solicitud. Asimismo, para garantizar la
                    seguridad de sus datos personales, la solicitud debe realizarse por escrito (a menos que la ley local reconozca
                    explícitamente una solicitud verbal);</p>
                <p>Debe proporcionar datos suficientes para que podamos verificar su identidad y asegurarnos de que la solicitud la
                    realiza el propio sujeto de datos o la persona legalmente autorizada;</p>
                <p>Una vez que hayamos adquirido suficiente información como para confirmar que podemos procesar su solicitud, le
                    responderemos dentro del tiempo establecido en las leyes aplicables de protección de datos. Específicamente,
                    nuestras respuestas incluyen:</p>
                <p>De acuerdo con sus requisitos y con las leyes y regulaciones aplicables, podemos proporcionarle una copia
                    gratuita
                    de sus datos personales colectados y procesados por nosotros. Para otras solicitudes de información pertinente,
                    es
                    posible que cobríamos una tarifa razonable basada en costos de administración reales de acuerdo con las leyes
                    aplicables.</p>
                <p>Si cree que nuestra información sobre usted es incorrecta o está incompleta, puede solicitar rectificar o
                    completar
                    los datos según el propósito de uso.</p>
                <p>Según las leyes y regulaciones aplicables, tiene el derecho a solicitar la cancelación de sus datos personales.
                    Su
                    solicitud se someterá a evaluación. Si cumple con las leyes y regulaciones correspondientes, eliminaremos su
                    información con los procedimientos relacionados que involucran medidas tecnológicas. Después de la eliminación
                    de la
                    información por usted o nosotros con su consentimiento, es posible que no podamos eliminarla del sistema de
                    respaldo
                    de inmediato debido a las leyes pertinentes y las tecnologías de seguridad. En este caso, aseguraremos su
                    información personal y la aislaremos de cualquier procesamiento posterior hasta que pueda ser borrada o
                    anonimizada.
                    Por ejemplo, conforme a la Ley de Comercio Electrónico de la República Popular China, la información de sus
                    productos y servicios y de las transacciones se conservarán durante al menos tres años a partir de la fecha de
                    finalización del negocio.</p>
                <p>Tenemos el derecho a rechazar el tratamiento de las siguientes solicitudes: una solicitud irrazonable o está en
                    disputa; que puede dañar la privacidad de otros; extremadamente irreal; que requiere un trabajo técnico
                    desproporcionado; que se puede ignorar de acuerdo con las leyes locales; la información ha sido divulgada
                    públicamente; la información ha sido divulgada bajo condiciones de confidencialidad. Si creemos que, en algunos
                    casos, la solicitud de eliminación o acceso a datos puede impedirnos utilizar legalmente los datos para los
                    fines de
                    seguridad y antifraude antes mencionados, también podemos rechazarla.</p>
                <p>(B) Retirada de consentimiento</p>
                <p>A través de enviarnos una solicitud, usted puede revocar su consentimiento a la recopilación, el uso y/o la
                    divulgación de su información personal que tenemos o controlamos. Según los servicios específicos que usted
                    utilice,
                    puede contactarnos usando la información de contacto en la sección 7 de esta política de privacidad.
                    Procesaremos su
                    solicitud dentro de un tiempo razonable después de que usted la entregó, y dejaremos de recopilar, usar y
                    divulgar
                    su información personal de acuerdo con su solicitud.</p>
                <p>.</p>
                <p>Por favor, tenga en cuenta que, según el alcance dentro del cual nos autorice a procesar sus datos, como
                    resultado
                    de su retirada de consentimiento, es posible que no pueda acceder a los servicios ofrecidos por Dreamehome o sus
                    dispositivos inteligentes conectados. Sin embargo, su decisión de revocar su consentimiento o autorización no
                    afectará el procesamiento previo de datos personales basados en su autorización.</p>
                <p>Asimismo, puede darse de baja en el Programa de Mejora de la Experiencia del Usuario a través de la solicitud de
                    la
                    retirada del consentimiento o via Dreamehome.</p>
                <p>(C) <strong>Borrar su cuenta de Dreamhome</strong></p>
                <p>Puede borrar su cuenta Dreamhome ingresando en "Yo" - "Configuración de la Cuenta" - "Borrar Cuenta". Si desea
                    borrar su cuenta Dreamehome, borrar su cuenta Dreamhome le impedirá seguir utilizando toda la línea de productos
                    y
                    servicios de hardware inteligente de Dreamehome, por lo que le sugerimos proceder con precaución. Para proteger
                    los
                    derechos e intereses legítimos de usted u otros, determinaremos si aprobar su solicitud de borrar su cuenta en
                    función de su uso de los productos y servicios de hardware inteligente de Dreamhome.</p>
                <p>.</p>
                <p>VI. Cómo manejamos la transferencia transfronteriza de datos</p>
                <p>Dado que ofrecemos productos y servicios basados en recursos y servidores en todo el mundo, con su
                    consentimiento,
                    su información personal puede ser transmitida a otras jurisdicciones fuera del país/región donde está utilizando
                    los
                    productos o servicios, o puede ser accedida por estas jurisdicciones. Las políticas de protección de datos y las
                    leyes pertinentes en el país/región donde su información puede ser transferida pueden no ser tan completas como
                    en
                    su país/región actual. En dichos casos, tomaremos las medidas legales apropiadas de acuerdo con las leyes
                    aplicables
                    de la jurisdicción correspondiente para garantizar que su información personal continúe protegida.</p>
                <p>Nota:</p>
                <p>Si es residente del Espacio Económico Europeo (EEE) y su información personal se transfiere fuera del EEE,
                    procesaremos su información personal dentro del área donde la Comisión Europea puede proporcionar un nivel
                    suficiente de protección; o implementaremos medidas de protección adecuadas para proteger su información
                    personal,
                    incluida la transferencia de su información según las regulaciones aplicables de transferencia de datos, como
                    las
                    Cláusulas Contractuales Tipo (SCC por sus siglas inglesas) de la Comisión Europea.</p>
                <p>VII. Nuestra información de contacto</p>
                <p>Si tiene algún comentario o duda sobre esta Política de Privacidad, o sobre nuestra colección, uso o divulgación
                    de
                    su información personal, póngase en contacto con nosotros a través de la forma de contacto a continuación o en
                    el
                    sitio web Dreamehome “Mi” – “Seguimiento y comentarios” indicando "Política de Privacidad" en el título. Nuestro
                    equipo de profesionales daré respuesta a sus dudas e inquietudes. Si su pregunta involucra asuntos importantes,
                    es
                    posible que le pidamos que proporcione más información. Si no está satisfecho con nuestra respuesta, puede
                    presentar
                    una reclamación ante la autoridad de supervisión pertinente en su jurisdicción. Si nos consulta, le
                    proporcionaremos
                    las posibles formas para hacer una reclamación en función de su situación real. </p>
                <p><strong>Correo Electrónico：</strong></p>
                <ul>
                    <li>Contacto de China：<a className="page"
                        href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                    <li>Contacto de Gerente de Privacidad de Singapur：<a className="page"
                        href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a> </li>
                    <li>Contacto de Representante en UUEE：<a className="page"
                        href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
                </ul>
                <p><strong>Teléfono：400-875-9511</strong></p>
                <p><strong>Sitio Web：</strong><a className="page"
                    href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a></p>
                <p>VIII. Cómo actualizamos los términos</p>
                <p>Dreame se reserva el derecho de actualizar esta Política de Privacidad cuando sea el tiempo adecuado. En caso de
                    algún cambio, le informaremos a través de un mensaje emergente o de otro medio destacado. Sólo con su
                    consentimiento
                    colectaremos, usaremos y guardaremos su información personal de acuerdo con la política actualizada.</p>
                <p>La presente política entra en vigor a partir de la fecha de actualización.</p>
                <p>Fecha de la última actualización: 28 / 08 / 2021</p>
                <p>Apéndice I: Detalles de los SDK de terceros</p>
                <p>*Dreamehome utiliza una serie de SDK de terceros para ofrecerle funciones y servicios fundamentales y adicionales
                    más profesionales y seguros. Lea más detalles sobre los SDK de terceros utilizados en Dreamehome a continuación:
                </p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDK</p>
                        </td>
                        <td>
                            <p>Funciones</p>
                        </td>
                        <td>
                            <p>Información colectada</p>
                        </td>
                        <td>
                            <p>Política de Privacidad de Terceros</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng SDK de análisis estadístico </p>
                        </td>
                        <td>
                            <p>Análisis estadístico</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD),
                                ubicacón</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng SDK de notificaciones push </p>
                        </td>
                        <td>
                            <p>Notificación push</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD),
                                ubicación</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng U-share SDK</p>
                        </td>
                        <td>
                            <p>Compartir con terceros</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI INFO OF SIM CARD),
                                ubicación</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK</p>
                        </td>
                        <td>
                            <p>Facilitar el chat de voz y el streaming</p>
                        </td>
                        <td>
                            <p>Información del dispositivo, estado de la red, cámara, micrófono, almacenamiento de lectura y
                                escritura</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identificador del dispositivo, modelo del dispositivo, tipo de red, almacenamiento del dispositivo,
                                información del proceso de operación del dispositivo, versión de la aplicación, versión del SDK</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO data-push SDK</p>
                        </td>
                        <td>
                            <p>Data-push</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>WeChat SDK</p>
                        </td>
                        <td>
                            <p>Iniciar sesión en WeChat, compartir en WeChat</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo, información de red</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Compartir en QQ</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo, información de red</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Iniciar sesión en Weibo, compartir en Weibo</p>
                        </td>
                        <td>
                            <p>Identificador de dispositivo, información de red</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Apple ID SDK</p>
                        </td>
                        <td>
                            <p>Iniciar sesión con Apple ID</p>
                        </td>
                        <td>
                            <p>Apple ID</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy